<template>
  <div class="content">
    <!-- 地址 -->
    <div class="address-section" @click="pickerAddress" v-if="type == 1">
      <div v-if="OrderAddress" class="order-content">
        <span class="yticon icon-shouhuodizhi"></span>
        <div class="cen">
          <div class="top">
            <span class="name">{{ OrderAddress.name }}</span>
            <span class="mobile">{{ OrderAddress.phone }}</span>
          </div>
          <span class="address">{{ OrderAddress.address }}</span>
        </div>
        <span
          @click.stop="toAddress"
          class="yticon icon-you flex-center"
        ></span>
      </div>
      <div v-else class="order-content">
        <span class="yticon icon-shouhuodizhi"></span>
        <div class="cen">请选择收货地址</div>
        <span
          @click.stop="toAddress"
          class="yticon icon-you flex-center"
        ></span>
      </div>
      <van-image
        lazy-load
        class="a-bg"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAAFCAYAAAAaAWmiAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Rjk3RjkzMjM2NzMxMTFFOUI4RkU4OEZGMDcxQzgzOEYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Rjk3RjkzMjQ2NzMxMTFFOUI4RkU4OEZGMDcxQzgzOEYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGOTdGOTMyMTY3MzExMUU5QjhGRTg4RkYwNzFDODM4RiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGOTdGOTMyMjY3MzExMUU5QjhGRTg4RkYwNzFDODM4RiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrEOZlQAAAiuSURBVHjazJp7bFvVHce/1/deXzuJHSdOM+fhpKMllI2SkTZpV6ULYrCHQGwrf41p/LENVk3QTipSWujKoyot1aQN0FYQQxtsMCS2SVuqsfFYHxBKYQNGV9ouZdA8nDipH4mT+HFf+51rO0pN0japrw9HreLe3Pqc3/me3+f3uFdIvfVuDIAPix1C9oceicFRVQWlvRWCkL1omqb1Of9z9rXZY65rhcO6x5ove19oWkX/RAaSMLOEkg+2Zt0wEcvoWOZzYZnXeWEbzmP7XPs11//LnOiDEY9DkGRwGw5a59QUTM2As+1qiD5v0TUvvC9Bc52KpmDSnju4ic7+CIinNVQoElYtcUM8jx2L1bzwPn14DOrHZ0hzEdxOPJtW16FH45CvuBzyZU22aH7Od9LnU/E0xpMqJG6iZ309qeqYNoA1gTJ4ZdF2zY2pJNSTfYCmkb85+GnO1hIbh+DzQVndaiHYTs3ZGJpifE/DyVnzi+X7pWqen8/i+8kPYUSjEORPCd9XtUKs9Fi+KMxjVzE0n9ZNnIgkYXwK+B5LafC4JKyudcMxD2+LqblGfNcY30VxJsfhcOCJ7xr02ATkluXE96DtmrPvPxFLIUH7zY3vOc0Z39O0oGtqy1DlFIuu+Zx8P/Ffa8/hEBey4rh0uuPWS6S6CRUhyGjG0hcfOWex+c9zXSsE5HmFzseP3H294Sl847VBRGJJQHTwy9wJNKAE7otLfXi2K3hRgeB81+bar8IDEPvFMxi6cxebnMx2cjrnDmiIwUAGDTvugX9de9E1L7R9NK1jc+8gnj8dy2rOKY/JRhgV8Cr405ea0HEBOxajeaHtySPvYvD2bUgdP0lmuzkl7oLl6Wn0wX/Dd1D/xG5bNc/f+7NjY9jyzghlM5QxS/ySOGt+Wlt3WwDXBz22a86gHrqjG7Hnekhz5uciN9NVDEBxXYng87vgEoqveZ7y+XsPE99vOTyAs1SkU+bOT3NKIJHUsIb4/rsL8L0YmrMRffQ3GNn8c6L7BOnu4pW10/xR4nsK9T+5FzWda2fXcEXTfLbtYUrc7joSwguno9kilZfsLNmgtaBcxv7rmudN2i9Fc8YRlsvkr6aOvoeBHxDf//MBzVfGke9p8vVhVN2wAQ1P7rFdczYeO34Wm4+Gsr4mcqzWMqQ5IX5rex3W1pUXX/PCRlwkjpEtDyLy9B8sPxcgLWzFpy7rWlTH3eq66AbUj0fh7lyJhn27oFzVck41mTdgdnU5+3fzbczsqqVwQ14aSuCrhwZoo3UEqCLW6biZJZZZom0e0UhlSiY3rvBjd0cdfLJjTrsXYvN8e5TvPEZ2PYbw9l9CrKqAWFNB+2+W/oiTc2l9BFefC/WPdqPyuxts1/zMlIrbqVB7OZSgaSWrC2eUWHUGcLa2MVrLyho3ftvVhNYq1ye6J8XUnI3JFw8idNdOaB+GIS+vsZhf6gMvsP1OJKGFx1H9o1sQeOSBXOcfc9pQDM3Z2PGvEeykxJ0l7AGaTyux4YKVLpOvs0BO/v0UQf17LdUzwdcskuaFHRo1NIrQxq1I9ByEc2kj+ZwDZsk1z/H9I+L7us+j4fHdUFa2FF3zQtv3DyTwrTcGoVFxXOeWKZEoPeNm+E66b7zSj71r6+ERHXN21C5V85nPmo7I3scRvncfxOoyiP7y0vNdyMZ17X9xmGR+43MPwvvtm23XnPH9h68P4u8U2yuJ7wonvmu0pigValf73XhmfRCt1S5bNbd6QK/0ov+2bhjDE8T3aj58p5hujCehjsZQs+lWLNl5N0RvuS2a5z/T8cLOd8K4/72wxdaAXHq+syGT7sOM7xLxvaOe+F5lu+bqYBjDd25H4s+vQ26ugSBL1lsEC+m4C8fQvMhXZXTa/CR8N96MekrapWCdvc1t+rvn32PY3juYrc7cEjjonFuMYQm97QsBPLSq1v7pKJAPbbwHZ3ueoqCyhJIJStqto8/BdMTh8q1A8PcPo+xrXbbP97ehSXydFWpjU0CZzO8xInM+CqSdTV688OVmBBT7O6DRh/dhYOt20nqSdK+f1RIqdRMqRXgrR90Dm+Dfsdn2+QYpeH7/8CBe+mAsq7nIsevKEjivgv1dQdzYUGH7dMlXe3FmwxZMTRyFgiZkW48mF0/XMYWqm75JfH8IUmPA1tlUMnHv+8T3N3J8d3Hkey6I3re6Djvaam1v/urhswjdsQ2jf/kVJRI1xHdPrh1lltzTWUxXai5H07N74P7KettnPDQyjWtf/ohglyJfl7jz/drP+vDrzgYsLZdtP2PRnz6B/u4t9I+U9cYCH81hddoFuBG4bxNq7v9xSfh+G/H9wKkIwF5JkR38fF3VLb73dDXhpsYS8P0Vxve7MZ14E04EkX2SumDj40Lkjz2LS9x1nZVqcK1rh1L/GaiZDB1GYwGPRi9+sA4r63odGEjAoKTZS0mTwUtoS2sTPioc1jd64KJqNZXRP9EtLFrLT5KQOd6H1JtvQ/SUQ1CUC1Z/tjp5MgXn51bAfc1VpAUVb6pqi+bsqRlrOB0ITSI0kUa1IvF7JcribPbxZnt9BYIeBZm0ap1BO2yHLMOIxjH111chmDocXg9XzZFR4fD74e5cA9GtQEulbLGbfaNMvv4+BfG3hiet9wxlUeDGdDPn68uqXVgVKKezbiBN/HHYoTnrqlORkDx0BHr/ABzVVbknbZysZ3wnRVyda6HU1UIjvpt28p2C+T+GEtYeeEh3jqcdKjl2BcWY65q9UAQb+c6+k3iePnaS+P5Pq8spOJ38fJ09RVI1OFuWo6xtJXSD+J6xh++OHN8PEt8HxtNY4pbAczC+m2Rnh8V3J9Q0Fa4LeG97YQdehj4aoSL9NZiZNMTKStp6g5/x5NsW37vWQaS1WXzPHvjihzYS/lgshbeJ75WySHm7wNXXk8SbK/xutOX4ntHtYRxE0eJn6uARaGf6ie++7GPNxVkf/78AAwCn1+RYqusbZQAAAABJRU5ErkJggg=="
      />
    </div>

    <div class="goods-section">
      <div class="g-header b-b"></div>
      <!-- 商品列表 -->
      <template v-if="preOrder.products">
        <div
          class="g-item"
          v-for="(item, index) in preOrder.products"
          :key="index"
        >
          <van-image
            lazy-load
            class="g-item-image"
            :src="item.picture"
            width="70"
            height="70"
            radius="2"
          />
          <div class="right">
            <span class="title clamp">{{ item.name }}</span>
            <span class="spec">{{ item.description }}</span>
            <div class="price-box">
              <span class="price">¥{{ item.price }}</span>
              <span class="number">x {{ item.quantity }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- 金额明细 -->
    <div class="yt-list">
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">商品金额</span>
        <span class="cell-tip"
          >￥{{ preOrder.price || preOrder.totalPrice }}</span
        >
      </div>
      <div class="yt-list-cell b-b" v-if="this.type != 3">
        <span class="cell-tit clamp">运费</span>

        <span class="cell-tip" v-if="OrderAddress">{{
          preOrder.freight > 0 ? "￥" + preOrder.freight : "免运费"
        }}</span>
        <span class="cell-tip" v-else>待计算</span>
      </div>
       <div class="yt-list-cell desc-cell" v-if="type == 3">
        <span class="cell-tit clamp">联系人</span>
        <input
          class="desc"
          style="text-align: right"
          type="text"
          v-model="consignee"
          placeholder="请填写联系人"
          placeholder-class="placeholder"
        />
      </div>
       <div class="yt-list-cell desc-cell" v-if="type == 3">
        <span class="cell-tit clamp">联系电话</span>
        <input
          class="desc"
          style="text-align: right"
          type="text"
          v-model="phone"
          placeholder="请填写联系人电话"
          placeholder-class="placeholder"
        />
      </div>
      <div class="yt-list-cell desc-cell">
        <span class="cell-tit clamp">备注</span>
        <input
          class="desc"
          style="text-align: right"
          type="text"
          v-model="desc"
          placeholder="请填写备注信息"
          placeholder-class="placeholder"
        />
      </div>
    </div>
    <!-- 优惠明细 -->
    <div class="yt-list">
      <div
        v-if="preOrder.backPointNumber > 0"
        class="yt-list-cell b-b"
        @click="toggleMask('show')"
      >
        <div class="cell-icon">赠</div>
        <span class="cell-tit clamp">赠送积分</span>
        <span class="cell-tip active">{{ preOrder.backPointNumber }}</span>
        <span class="cell-more wanjia wanjia-gengduo-d"></span>
      </div>
      <!-- <div v-if="preOrder.mostPointCanUse > 0" class="yt-list-cell">
        <div class="cell-icon hb">抵</div>
        <span class="cell-tit clamp"
          >可最多使用{{ preOrder.mostPointCanUse }}积分抵扣¥{{
            preOrder.mostPointCanUse / preOrder.howMuchPointIsOneYuan
          }}</span
        >
      </div> -->
      <div v-if="preOrder.mostPointCanUse > 0" class="yt-list-cell">
        <!-- <div class="hb"></div> -->
        <div class="cell-icon hb">抵</div>
        <span class="cell-tit clamp">抵扣积分数量</span>
        <span>{{ preOrder.mostPointCanUse }}个</span>
        <!-- <input
          ref="points"
          v-model="inputMostPointCanUse"
          class="desc"
          @input="changePoints($event.target)"
          style="text-align: right"
          type="number"
          placeholder="请输入抵扣积分数量"
          placeholder-class="placeholder"
        /> -->
      </div>
      <div v-if="preOrder.memberDiscount > 0" class="yt-list-cell">
        <div class="cell-icon lpk">折</div>
        <span class="cell-tit clamp">会员折扣</span>
        <span class="cell-tip">-￥{{ preOrder.memberDiscount }}</span>
      </div>
      <div
        v-if="preOrder.couponStockList && preOrder.couponStockList.length > 0"
        class="yt-list-cell"
        @click="toggleCouponList"
      >
        <div class="cell-icon quan">券</div>
        <span class="cell-tit clamp">优惠券</span>
        <span class="cell-tip">{{
          couponPrice ? "-¥" + couponPrice : "选择优惠券"
        }}</span>
      </div>
      <div
        v-if="preOrder.shoppingCardList && preOrder.shoppingCardList.length > 0"
        class="yt-list-cell"
        @click="toggleCardList"
      >
        <div class="cell-icon card">卡</div>
        <span class="cell-tit clamp">购物卡</span>
        <span class="cell-tip">{{
          this.cardIds && this.cardIds.length > 0
            ? "已选择购物卡"
            : "选择购物卡"
        }}</span>
      </div>
    </div>

    <!-- 底部 -->
    <div class="footer">
      <div class="price-content">
        <span style="color: #999; font-size: 12px; margin-right: 10px"
          >实付款</span
        >
        <div v-if="money >= 0" class="d-flex flex-row align-items-center">
          <span class="price-tip">￥</span>
          <span class="price">{{ money }}</span>
        </div>
        <div v-else class="d-flex flex-row align-items-center">
          <span class="price-tip">￥</span>
          <span class="price">{{
            0 || preOrder.price || preOrder.totalPrice
          }}</span>
        </div>
        <span v-if="inputMostPointCanUse * 1 > 0">+</span>
        <div
          v-if="inputMostPointCanUse * 1 > 0"
          class="d-flex flex-row align-items-center"
        >
          <span class="price">{{ inputMostPointCanUse * 1 }}</span>
          <span class="price-tip">积分</span>
        </div>
      </div>
      <span class="submit" @click="submit">提交订单</span>
    </div>

    <van-popup
      v-model="showAddressPicker"
      position="top"
      :style="{ maxHeight: '50%' }"
    >
      <div v-if="addressList.length > 0">
        <div
          class="list border-bottom"
          v-for="(item, index) in addressList"
          :key="index"
          @click="checkAddress(item)"
        >
          <div class="wrapper">
            <div class="address-box">
              <span v-if="item.defaulted" class="tag">默认</span>
              <span class="address">{{ item.address }} {{ item.area }}</span>
            </div>
            <div class="u-box">
              <span class="name">{{ item.name }}</span>
              <span class="mobile">{{ item.phone }}</span>
            </div>
          </div>
          <span
            v-if="item.id == OrderAddress.id"
            :style="{ fontSize: '22px', color: 'var(--theme-font-color)' }"
            class="yticon icon-xuanzhong2"
          ></span>
        </div>
      </div>
      <div
        @click="addAddress('add')"
        :style="{ height: '100px' }"
        class="flex-center"
        v-if="addressList.length == 0"
      >
        没用可用的地址，点击前往增加>
      </div>
    </van-popup>

    <van-popup
      v-model="showCoupon"
      position="bottom"
      :style="{ maxHeight: '40%', background: '#f3f3f3' }"
      safe-area-inset-bottom
    >
      <my-coupon-own-list
        :fullNumber="preOrder.canUseCouponAmount"
        :couponList="preOrder.couponStockList"
        @reCoupon="reCoupon"
        @cancelCoupon="cancelCoupon"
      ></my-coupon-own-list>
    </van-popup>
    <van-popup
      v-model="showCardList"
      position="bottom"
      :style="{ maxHeight: '40%', background: '#f3f3f3' }"
      safe-area-inset-bottom
    >
      <my-shoppingcard-list
        :shopCardList="preOrder.shoppingCardList"
        @changeCardList="changeCardList"
      ></my-shoppingcard-list>
    </van-popup>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      activity: "",
      OrderAddress: null,
      productId: null,
      stodckId: null,
      num: 0,
      maskState: 0, //优惠券面板显示状态
      desc: "", //备注
      consignee:'',
      phone:'',
      payType: 1, //1微信 2支付宝
      couponList: [],
      preOrder: {},
      inputMostPointCanUse: "",
      inputMostMoneyCanUse: "",
      showAddressPicker: false,
      addressList: [],
      showCoupon: false,
      showCardList: false,
      couponStockId: null,
      couponPrice: 0,
      cardIds: [],
      cardPrice: 0,
      type: null,
      relPrice: 0,
    };
  },
  watch: {
    OrderAddress(val) {
      if (val !== null) {
        this.getPreOrder();
      }
    },
    couponPrice(val) {
      this.relPrice = this.preOrder.discountAmount - val;
    },
  },
  created() {
    console.log(this.$route.query);

    let query = this.$route.query;
    this.type = query.categoryType;
    this.activity = query.activity;
    if (query.productId) {
      this.productId = query.productId * 1;
      this.stodckId = query.stockId == "null" ? null : query.stockId * 1;
      this.num = query.num * 1;
      this.marketingCampaignType = query.marketingCampaignType;
      this.groupBuyGroupId = query.groupBuyGroupId;
    }
    this.loadData();
    let params = this.$route.params;
    console.log(this.$route.params);
    if(params.categoryType) {
      this.type = params.categoryType;
    }
    if (params.refreshData) {
      this.refreshPreData = params.refreshData;
    }
  },
  computed: {
    ...mapState(["hasLogin", "userInfo"]),
    money() {
      let { freight, discountAmount, totalPrice } = this.preOrder;
      freight = freight ? freight : 0;
      let { inputMostMoneyCanUse, couponPrice, cardPrice } = this;
      inputMostMoneyCanUse = inputMostMoneyCanUse ? inputMostMoneyCanUse : 0;
      let money = discountAmount - couponPrice;
      if (money <= 0) {
        money = freight;
      }
      // money = money + freight - inputMostMoneyCanUse - cardPrice
      if (cardPrice !== 0) {
        money = money - inputMostMoneyCanUse - cardPrice;
        if (money <= 0) {
          money = 0;
        }
      }
      return money;
    },
  },
  methods: {
    toggleCouponList() {
      this.showCoupon = !this.showCoupon;
    },
    toggleCardList() {
      this.showCardList = !this.showCardList;
    },
    changeCardList(ids) {
      this.cardIds = ids;
      this.cardPrice = 0;
      for (let card of this.preOrder.shoppingCardList) {
        if (this.cardIds.indexOf(card.id) > -1) {
          this.cardPrice += card.balance;
        }
      }
    },
    reCoupon(coupon) {
      this.couponStockId = coupon.couponStockId;
      this.couponPrice = coupon.denomination;
    },
    cancelCoupon() {
      this.couponStockId = null;
      this.couponPrice = 0;
    },
    loadData() {
      this.getPreOrder();
      this.getAddressList();
    },
    setAddress(address) {
      this.OrderAddress = address;
    },
    toAddress() {
      this.$router.push({
        name: "Address",
      });
    },
    pickerAddress() {
      this.showAddressPicker = !this.showAddressPicker;
    },
    getAddressList() {
      this.$http.request(this.$http.pathMap.addressList, "get").then((res) => {
        this.addressList = res.data;
        this.OrderAddress = res.data[0];
      });
    },
    getPreOrder() {
      if (this.productId != null) {
        //正常下单
        let params = {
          productId: this.productId,
          quantity: this.num,
          courseId: this.productId,
        };
        if (this.activity) {
          params.activity = this.activity;
        }
        if (this.stodckId != null) {
          params.stockId = this.stodckId;
        }
        if (this.marketingCampaignType != null) {
          params.marketingCampaignType = this.marketingCampaignType;
        }
        if (this.groupBuyGroupId != null) {
          params.groupBuyGroupId = this.groupBuyGroupId;
        }
        if (this.OrderAddress != null) {
          params.addressId = this.OrderAddress.id;
        }
        let url = "";
        if (this.type == 2) {
          url = this.$http.pathMap.orderCoursePre;
        } else if (this.type == 1) {
          url = this.$http.pathMap.orderPre;
        } else {
          url = this.$http.pathMap.virtualPre;
        }
        this.$http.request(url, "get", params).then((res) => {
          this.preOrder = res.data;
        });
      } else {
        let addressId = "";
        if (this.OrderAddress != null) {
          addressId = this.OrderAddress.id;
        }
        this.$http
          .request(this.$http.pathMap.orderPre, "get", { addressId })
          .then((res) => {
            this.preOrder = res.data;
          });
      }
    },

    //显示优惠券面板
    toggleMask(type) {
      let timer = type === "show" ? 10 : 300;
      let state = type === "show" ? 1 : 0;
      this.maskState = 2;
      setTimeout(() => {
        this.maskState = state;
      }, timer);
    },
    numberChange(data) {
      this.number = data.number;
    },
    changePayType(type) {
      this.payType = type;
    },
    changePoints(target) {
      if (target.value) {
        if (target.value * 1 < this.preOrder.mostPointCanUse) {
          this.inputMostPointCanUse = target.value;
        } else {
          this.inputMostPointCanUse = this.preOrder.mostPointCanUse;
        }
        this.inputMostMoneyCanUse =
          this.inputMostPointCanUse / this.preOrder.howMuchPointIsOneYuan;
        // console.log(this.inputMostPointCanUse)
      } else {
        this.inputMostMoneyCanUse = 0;
      }
    },
    submit() {
      if (!this.preOrder.address && this.type == 1) {
        this.$toast("请选择一个收货地址");
        return;
      }
      // if (!this.userInfo.phone) {
      //   this.$router.push('/pages/public/bindPhone')
      //   return;
      // }
      let params = {
        addressId: this.preOrder.address ? this.preOrder.address.id : "",
        carts: this.preOrder.products,
        remark: this.desc,
        phone:this.phone,
        consignee:this.consignee,
        usePointNumber: this.preOrder.mostPointCanUse,
        courseId: this.productId,
        productId:this.productId,
        quantity:this.num,
        productStockId:this.stodckId
      };
      if (this.marketingCampaignType != null) {
        params.marketingCampaignType = this.marketingCampaignType;
      }
      if (this.groupBuyGroupId != null) {
        params.groupBuyGroupId = this.groupBuyGroupId;
      }
      if (this.couponStockId != null) {
        params.couponStockId = this.couponStockId;
      }
      if (this.cardIds && this.cardIds.length) {
        params.shoppingCardIds = this.cardIds;
      }
      if (this.activity) {
        params.activity = this.activity;
      }
      let url = "";
      if (this.type == 2) {
        url = this.$http.pathMap.orderCoudseSubmit;
      } else if (this.type == 1) {
        url = this.$http.pathMap.orderSubmit;
      } else {
        url = this.$http.pathMap.virtualOrderSubmit;
      }
      this.$http.request(url, "post", params).then((res) => {
        this.$router.replace({
          path: "/pages/money/pay",
          query: { orderNo: res.data },
        });
        if (this.refreshPreData) {
          this.refreshPreData();
        }
      });
    },
    checkAddress(item) {
      this.setAddress(item);
      this.pickerAddress();
    },
    addAddress(type, item) {
      this.$router.push({
        path: "/pages/address/addressManage",
        query: {
          type,
          data: JSON.stringify(item),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding-bottom: 50px;
  background: #f8f8f8;
}

.address-section {
  padding: 15px 0;
  background: #fff;
  position: relative;

  .order-content {
    display: flex;
    align-items: center;
  }

  .icon-shouhuodizhi {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    color: #888;
    font-size: 22px;
  }

  .cen {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 14px;
    color: $font-color-dark;
  }

  .name {
    font-size: 17px;
    margin-right: 12px;
  }

  .address {
    margin-top: 8px;
    margin-right: 10px;
    color: $font-color-light;
  }

  .icon-you {
    height: 50px;
    width: 50px;
    font-size: 16px;
    color: $font-color-light;
  }

  .a-bg {
    position: absolute;
    left: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 2px;
  }
}

.goods-section {
  margin-top: 20px;
  background: #fff;
  padding-bottom: 1px;

  .g-header {
    display: flex;
    align-items: center;
    height: 0;
    padding: 0 15px;
    position: relative;
  }

  .logo {
    display: block;
    width: 25px;
    height: 25px;
    border-radius: 100px;
  }

  .name {
    font-size: 15px;
    color: $font-color-base;
    margin-left: 12px;
  }
  .g-image {
    margin: 10px;
  }
  .g-item {
    display: flex;
    margin: 10px 15px;

    .g-item-image {
      flex-shrink: 0;
      display: block;
      width: 70px;
      height: 70px;
      border-radius: 2px;
    }

    .right {
      flex: 1;
      padding-left: 12px;
      overflow: hidden;
    }

    .title {
      font-size: 15px;
      color: $font-color-dark;
    }

    .spec {
      font-size: 13px;
      color: $font-color-light;
    }

    .price-box {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: $font-color-spec;
      padding-top: 5px;

      .price {
        margin-bottom: 2px;
      }

      .number {
        font-size: 13px;
        color: $font-color-base;
        margin-left: 10px;
      }
    }

    .step-box {
      position: relative;
    }
  }
}

.yt-list {
  margin-top: 8px;
  background: #fff;
}

.yt-list-cell {
  display: flex;
  align-items: center;
  padding: 5px 15px 5px 20px;
  line-height: 35px;
  position: relative;
  &.cell-hover {
    background: #fafafa;
  }

  &.b-b:after {
    left: 15px;
  }

  .cell-icon {
    height: 16px;
    width: 16px;
    font-size: 11px;
    color: #fff;
    text-align: center;
    line-height: 16px;
    background: #f85e52;
    border-radius: 2px;
    margin-right: 6px;

    &.hb {
      background: #ffaa0e;
    }

    &.lpk {
      background: #3ab54a;
    }
    &.quan {
      background: #f56c6c;
    }
    &.card {
      background: blue;
    }
  }

  .cell-more {
    align-self: center;
    font-size: 12px;
    color: $font-color-light;
    margin-left: 4px;
    margin-right: -5px;
  }

  .cell-tit {
    flex: 1;
    font-size: 13px;
    color: $font-color-light;
    margin-right: 5px;
    
  }

  .cell-tip {
    font-size: 13px;
    color: $font-color-dark;

    &.disabled {
      color: $font-color-light;
    }

    &.active {
      color: $base-color;
    }

    &.red {
      color: $base-color;
    }
  }

  &.desc-cell {
    .cell-tit {
      // max-width: 45px;
    }
  }

  .desc {
    flex: 1;
    font-size: $uni-font-size-base;
    color: $font-color-dark;
  }
}

/* 支付列表 */
.pay-list {
  padding-left: 20px;
  margin-top: 8px;
  background: #fff;

  .pay-item {
    display: flex;
    align-items: center;
    padding-right: 10px;
    line-height: 1;
    height: 55px;
    position: relative;
  }

  .icon-weixinzhifu {
    width: 40px;
    font-size: 20px;
    color: #6bcc03;
  }

  .icon-alipay {
    width: 40px;
    font-size: 20px;
    color: #06b4fd;
  }

  .icon-xuanzhong2 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font-size: 20px;
    color: $base-color;
  }

  .tit {
    font-size: 16px;
    color: $font-color-dark;
    flex: 1;
  }
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 995;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  justify-content: space-between;
  font-size: 15px;
  background-color: #fff;
  z-index: 998;
  color: $font-color-base;

  .price-content {
    padding-left: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .price-tip {
    color: $font-color-spec;
    margin-left: 4x;
  }

  .price {
    font-size: 18px;
    color: $font-color-spec;
  }

  .submit {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    background-color: $base-color;
    width: 100px;
    height: 36px;
    border-radius: 18px;
    opacity: 1;
    margin-right: 20px;
  }
}

/* 优惠券面板 */
.mask {
  display: flex;
  align-items: flex-end;
  position: fixed;
  left: 0;
  top: var(--window-top);
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0);
  z-index: 9995;
  transition: 0.3s;

  .mask-content {
    width: 100%;
    min-height: 30vh;
    max-height: 70vh;
    background: #f3f3f3;
    transform: translateY(100%);
    transition: 0.3s;
    overflow-y: scroll;
  }

  &.none {
    display: none;
  }

  &.show {
    background: rgba(0, 0, 0, 0.4);

    .mask-content {
      transform: translateY(0);
    }
  }
}

/* 优惠券列表 */
.coupon-item {
  display: flex;
  flex-direction: column;
  margin: 10px 12px;
  background: #fff;

  .con {
    display: flex;
    align-items: center;
    position: relative;
    height: 60px;
    padding: 0 15px;

    &:after {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      width: 100%;
      height: 0;
      border-bottom: 1px dashed #f3f3f3;
      transform: scaleY(50%);
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    overflow: hidden;
    height: 50px;
  }

  .title {
    font-size: 16px;
    color: $font-color-dark;
    margin-bottom: 5px;
  }

  .time {
    font-size: 12px;
    color: $font-color-light;
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: $font-color-base;
    height: 50px;
  }

  .price {
    font-size: 22px;
    color: $base-color;

    &:before {
      content: "￥";
      font-size: 17px;
    }
  }

  .tips {
    font-size: 12px;
    color: $font-color-light;
    line-height: 30px;
    padding-left: 30px;
  }

  .circle {
    position: absolute;
    left: -3px;
    bottom: -5px;
    z-index: 10;
    width: 10px;
    height: 10px;
    background: #f3f3f3;
    border-radius: 100px;

    &.r {
      left: auto;
      right: -3px;
    }
  }
}
.list {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background: #fff;
  position: relative;
}
.wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.address-box {
  display: flex;
  align-items: center;
  .tag {
    min-width: 40px;
    text-align: center;
    font-size: 12px;
    color: $base-color;
    margin-right: 5px;
    background: #fffafb;
    border: 1px solid #ffb4c7;
    border-radius: 2px;
    padding: 2px 5px;
    line-height: 1;
  }
  .address {
    font-size: 15px;
    color: $font-color-dark;
  }
}
.u-box {
  font-size: 14px;
  color: $font-color-light;
  margin-top: 8px;
  .name {
    margin-right: 15px;
  }
}
.icon-bianji {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 20px;
  color: $font-color-light;
  padding-left: 15px;
}
</style>
